import React, { ReactNode } from 'react';
import { FlagsProvider } from 'flagged';

import { useServerFeatureFlags } from './hooks';

interface AppFeatureFlagsProviderProps {
  children: ReactNode;
}

export const AppFeatureFlagsProvider: React.FC<AppFeatureFlagsProviderProps> = ({ children }) => {
  const featureFlags = useServerFeatureFlags();

  return <FlagsProvider features={featureFlags.data}>{children}</FlagsProvider>;
};
